import { useAppNavigationContext } from '@h2oai/ui-kit';
import { ReactNode, useEffect } from 'react';

import { NoItemView } from '../../../components/NoItemView/NoItemView';
import { useWorkspaces } from '../../Orchestrator/WorkspaceProvider';

interface RequireWorkspacesProps {
  children: ReactNode;
}

/**
 * Guard component that wraps content requiring workspace context
 * Handles workspace initialization errors and enables workspace dropdown
 */
export const RequireWorkspaces = ({ children }: RequireWorkspacesProps) => {
  const { enableWorkspacesDropdown, disableWorkspacesDropdown } = useAppNavigationContext();
  const workspaceContext = useWorkspaces();

  useEffect(() => {
    enableWorkspacesDropdown();
    return disableWorkspacesDropdown;
  }, [enableWorkspacesDropdown, disableWorkspacesDropdown]);

  if (workspaceContext.initializationError) {
    return (
      <NoItemView
        actionIcon="Error"
        title="Workspace Initialization Error"
        description={workspaceContext.initializationError}
        actionTitle="Retry"
        onActionClick={() => {
          window.location.reload();
        }}
      />
    );
  }

  return <>{children}</>;
};
